import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ActionSelector.css';

const ActionSelector: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="action-selector">
      <div className="step-header">
        <button onClick={() => navigate('/cash')} className="back-btn">← Dashboard</button>
      </div>

      <h2>Select Action</h2>
      <p>What would you like to do?</p>

      <div className="action-buttons">
        <button onClick={() => navigate('/cash/add')} className="action-btn">
          <div className="btn-icon">＋</div>
          <div className="btn-content">
            <h3>Add Cash</h3>
            <p>Record a cash payment or bank withdrawal</p>
          </div>
        </button>
        <button
          onClick={() => navigate('/cash/daily-closing')}
          className="action-btn daily-closing-btn"
        >
          <div className="btn-icon">🏪</div>
          <div className="btn-content">
            <h3>Daily Closing</h3>
            <p>Count cash in till and record daily closing</p>
          </div>
        </button>

        <button
          onClick={() => navigate('/cash/withdrawal')}
          className="action-btn cash-withdrawal-btn"
        >
          <div className="btn-icon">💰</div>
          <div className="btn-content">
            <h3>Cash Withdrawal</h3>
            <p>Record cash taken from till</p>
          </div>
        </button>

        <button
          onClick={() => navigate('/cash/spending')}
          className="action-btn cash-spending-btn"
        >
          <div className="btn-icon">🛒</div>
          <div className="btn-content">
            <h3>Cash Spending</h3>
            <p>Record how you spent withdrawn cash</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ActionSelector;
